module.exports = __webpack_public_path__ + "img/notification-icon-dark.71e93641.svg";